var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint0_linear_87_10397)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint1_linear_87_10397)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_87_10397)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#E2E4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1001 46.3648V48.5593C45.1498 48.2233 44.1327 48.1202 43.1343 48.2588C42.1359 48.3973 41.1853 48.7734 40.3623 49.3554C39.5393 49.9374 38.8681 50.7085 38.4048 51.6037C37.9416 52.4989 37.6999 53.4922 37.7001 54.5002L35.6001 54.4991C35.5998 53.217 35.893 51.9517 36.4572 50.8004C37.0215 49.6491 37.8418 48.6422 38.8553 47.8569C39.8689 47.0716 41.0487 46.5287 42.3045 46.2699C43.5603 46.0111 44.8586 46.0432 46.1001 46.3637V46.3648ZM44.0001 45.0502C40.5193 45.0502 37.7001 42.2309 37.7001 38.7502C37.7001 35.2694 40.5193 32.4502 44.0001 32.4502C47.4808 32.4502 50.3001 35.2694 50.3001 38.7502C50.3001 42.2309 47.4808 45.0502 44.0001 45.0502ZM44.0001 42.9502C46.3206 42.9502 48.2001 41.0707 48.2001 38.7502C48.2001 36.4297 46.3206 34.5502 44.0001 34.5502C41.6796 34.5502 39.8001 36.4297 39.8001 38.7502C39.8001 41.0707 41.6796 42.9502 44.0001 42.9502ZM50.9154 49.2502L48.9949 47.3308L50.4807 45.845L54.9348 50.3002L50.4807 54.7553L48.9949 53.2696L50.9154 51.3502H47.1501V49.2502H50.9154Z",
    fill: "#525866"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_87_10397",
    x: 12,
    y: 14,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_10397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_10397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_10397",
    x1: 44,
    y1: 0,
    x2: 44,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E5E7",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F8F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_10397",
    x1: 44,
    y1: 0,
    x2: 44,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E4E5E7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/CustomIcon.8e599a7a4f44cce8478d1716a70192a4.svg";
export { ForwardRef as ReactComponent };